import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { LOGO } from "../data";
const LINKS = [
  { label: "Services", id: "services" },
  { label: "Réalisations", id: "realisations" },
  { label: "Rendez-vous", id: "rdv" },
  { label: "Contact", id: "contact" },
];

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
  else el.scrollIntoView({ behavior: "smooth" });
}

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    setTimeout(() => scrollToId(id), 10);
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 z-50 w-full transition-colors duration-300 ${
        scrolled ? "glass border-b border-white/10" : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <button
          onClick={() => go("hero")}
          className="flex items-center gap-3"
          data-testid="navbar-logo"
        >
          <img src={LOGO} alt="Logo Event's Multitechnique" className="h-10 w-auto" />
          <span className="flex flex-col leading-none">
            <span className="font-head text-lg font-bold uppercase tracking-tight text-white">
              Services
            </span>
            <span className="text-[9px] tracking-[0.25em] text-white/60">
              EVENT'S MULTITECHNIQUE
            </span>
          </span>
        </button>

        <div className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              className="group relative text-sm font-medium text-white/70 transition-colors hover:text-white"
              data-testid={`nav-link-${l.id}`}
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-brand-gradient transition-[width] duration-300 group-hover:w-full" />
            </button>
          ))}
          <button
            onClick={() => go("devis")}
            className="rounded-full bg-brand-gradient px-6 py-2.5 text-sm font-semibold text-white transition-transform duration-300 hover:scale-105"
            data-testid="nav-devis-btn"
          >
            Demander un devis
          </button>
        </div>

        <button
          className="text-white md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          className="glass border-t border-white/10 md:hidden"
          data-testid="nav-mobile-menu"
        >
          <div className="flex flex-col gap-1 px-5 py-4">
            {LINKS.map((l) => (
              <button
                key={l.id}
                onClick={() => go(l.id)}
                className="py-3 text-left text-base font-medium text-white/80"
                data-testid={`nav-mobile-link-${l.id}`}
              >
                {l.label}
              </button>
            ))}
            <button
              onClick={() => go("devis")}
              className="mt-2 rounded-full bg-brand-gradient px-6 py-3 text-center text-sm font-semibold text-white"
              data-testid="nav-mobile-devis-btn"
            >
              Demander un devis
            </button>
          </div>
        </motion.div>
      )}
    </motion.header>
  );
}
